var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from "vue-property-decorator";
var IndexMixins = /** @class */ (function (_super) {
    __extends(IndexMixins, _super);
    function IndexMixins() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // data() {
        //     return {
        //
        // },
        // methods: {},
        _this.tabList = [
            { title: "平台", icon: "plant" },
            { title: "应用", icon: "yingyong" },
            { title: "大数据", icon: "data" },
        ];
        _this.tabIndex = 0;
        _this.meDataList = [
            {
                title: "核 心理 念",
                content: "以新时代中国特色社会主义思想为指导，以落实立德树人根本任务为宗旨，着力构建“三全育人”机制，聚焦 “双核”（职业院校学生核心素养与核心技能）培养，努力让每个学生都有人生出彩的机会。",
            },
            {
                title: "团 队作 风",
                content: "我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
            },
            {
                title: "企 业精 神",
                content: "展望未来，文熹科技将始终坚持专注教育、潜心研发、服务用户，不断推动高职教育信息化发展进程，努力成为教育信息化领域的旗帜性企业，为智慧型校园的构建奉献全部力量。",
            },
        ];
        _this.meavitve = 0;
        _this.scollList = [
            "厦门技师学院",
            "江苏工程职业技术学院",
            "江苏省东台中等专业学校",
            "冀南技师学院",
            "江苏省如东中等专业学校",
            "略阳县天津职业技术教育中心学校",
            "江苏省海门中等专业学校",
            "苏州建设交通高等职业技术学校",
            "江苏省邗江中等专业学校",
            "江苏省扬州旅游商贸学校",
            "江苏省常熟中等专业学校",
            "扬州生活科技学校",
            "无锡汽车工程高等职业技术学校",
            "江苏省高邮中等专业学校",
            "无锡卫生高等职业技术学校",
            "邗江中等专业学校",
            "常州刘国钧高等职业技术学校",
            "泰州机电高等职业技术学校",
            "江苏省溧阳中等专业学校",
            "江苏省姜堰中等专业学校",
            "连云港中医药高等职业技术学校",
            "江苏省兴化中等专业学校",
            "淮安生物工程高等职业学校",
            "江苏省靖江中等专业学校",
            "江苏省淮安工业中等专业学校",
            "淮安市高级职业技术学校",
            "盐城机电高等职业技术学校",
            "江苏省东台中等专业学校",
            "更多合作院校...",
        ];
        _this.dataList = [
            {
                title: "关于我们",
                contentList: ["公司简介", " 商务合作"],
            },
            {
                title: "解决方案",
                contentList: [
                    "学生成长平台",
                    "  老师发展平台",
                    "班集体建设平台",
                    "校园活动平台",
                    " 心理健康平台",
                    " 劳动教育平台",
                    "流程管理平台",
                ],
            },
        ];
        _this.tabactive = 0;
        return _this;
    }
    Object.defineProperty(IndexMixins.prototype, "computeHeight", {
        // computed
        // 计算高度
        get: function () {
            var screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '550px';
            }
            else {
                return '70vmin';
            }
        },
        enumerable: false,
        configurable: true
    });
    IndexMixins = __decorate([
        Component
    ], IndexMixins);
    return IndexMixins;
}(Vue));
export default IndexMixins;
